import { QueryClient } from 'react-query'

// Single app-wide React Query client, exported so the auth provider can flush
// it on login/logout. React Admin builds list query keys from
// [resource, pagination, sort, filter] only — the user token is NOT part of the
// key — so without an explicit clear at auth boundaries one browser can serve a
// previous session's (or pre-remediation) cached data. That is exactly how the
// stale portfolioTeam list survived in a normal window while incognito (no
// cache) showed the correct result. See authProvider login/logout.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // staleTime intentionally left at 0 so lists refetch on mount.
      refetchOnWindowFocus: false,
      // react-query fires a background refetch on reconnect (laptop wake / wifi blip).
      // A single transient failure used to surface immediately as a hard error and
      // strand the page. Retry transient/network failures a few times with backoff so
      // they self-heal before reaching the error boundary — but do NOT retry auth
      // failures, so an archived/invalid token still surfaces fast and logs the user out.
      retry: (failureCount: number, error: any) => {
        const status = error?.status
        const message = String(error?.message ?? '')
        if (status === 401 || status === 403 || message.startsWith('usr.aut')) return false
        return failureCount < 3
      },
      retryDelay: (attempt: number) => Math.min(1000 * 2 ** attempt, 30000),
    },
  },
})
